const STORAGE_KEY = 'searchHistory'

import eventBus from '@/eventBus'

const historyMixin = {
    methods: {
        getHistorys () {
            const h = localStorage.getItem(STORAGE_KEY) || '[]'
            return JSON.parse(h)
        },
        saveHistory (item) {
            if (!item) return

            const h = localStorage.getItem(STORAGE_KEY) || '[]'
            const newH = JSON.parse(h)
                             .filter(hi => hi !== item)
                             .slice(0, 6)
            newH.unshift(item)
            localStorage.setItem(STORAGE_KEY, JSON.stringify(newH))

            eventBus.$emit('historiesUpdated', newH)
        },
        removeHistory (item) {
            if (!item) return

            const h = localStorage.getItem(STORAGE_KEY) || '[]'
            const newH = JSON.parse(h)
                             .filter(hi => hi !== item)
            
            localStorage.setItem(STORAGE_KEY, JSON.stringify(newH))
            eventBus.$emit('historiesUpdated', newH)
        },
        removeAll () {
            localStorage.setItem(STORAGE_KEY, '[]')
            eventBus.$emit('historiesUpdated', [])
        }
    },
    created () {
    }
}

export default historyMixin



// WEBPACK FOOTER //
// ./src/mixins/history.js